import axios from 'axios';
import React, { Component } from 'react';
import { Button } from '@material-ui/core';
import css from './bfm.css';
import { ROOT_URL } from '../../Actions/types';

class UploadBankFeedForm extends Component {
  state = { fileUploaded: false, uploading: false };

  handleUploadFile = (event) => {
    const file = event.target.files[0];
    const fileName = file.name.toLocaleLowerCase();
    if (fileName.includes('.pdf')) {
      this.setState({ uploading: true });
      const data = new FormData();
      data.append('file', file);
      axios
        .post(`${ROOT_URL}/bankfeed/form/${this.props.feed.feedId}`, data, {
          headers: {
            authorizationtoken: localStorage.getItem('token'),
            cognitotoken: localStorage.getItem('cognitotoken'),
            authtype: localStorage.getItem('authtype'),
          },
        })
        .then(() => {
          this.setState({ fileUploaded: true });
          this.props.reloadFeed();
        })
        .catch((err) => {
          this.props.showError('There was a problem uploading your file');
        });
    } else {
      this.props.showError('You may only upload files in pdf format');
    }
  };

  render() {
    const { onClose, feed, downloadForm } = this.props;

    if (this.state.fileUploaded) {
      return (
        <div className={[css.w400, css.fontSmall].join(' ')}>
          Your registration form has been uploaded and sent to the bank for processing. Once the bank has processed your application the
          feed status will change to 'Active'.
          <div className={css.dividerDark} />
          <div>
            <Button type='button' variant='contained' size='small' onClick={onClose}>
              Close
            </Button>
          </div>
        </div>
      );
    }

    return (
      <div className={[css.w400, css.fontSmall].join(' ')}>
        <div className={css.dFlexForm}>
          <div className={[css.flex1, css.muted].join(' ')}>
            <i className='far fa-check-circle fa-3x' />
          </div>
          <div className={css.flex3}>Steps to uploading your bank feed registration form to the bank</div>
        </div>

        <div className={css.dividerLight} />
        <div className={css.dFlexForm}>
          <div className={[css.flex1, css.muted].join(' ')}>
            <i className='far fa-list-alt fa-3x' />
          </div>
          <div className={css.flex3}>
            <ul className={css.formList}>
              <li className={css.listPoint}>Print and complete the Form</li>
              <li className={css.listPoint}>Scan the Form</li>
              <li className={css.listPoint}>Make sure the scan is good quality and save as a PDF file</li>
            </ul>
          </div>
        </div>

        <div className={css.dividerLight} />
        <div className={css.dFlexForm}>
          <div className={[css.flex1, css.muted].join(' ')}>
            <i className='fas fa-cloud-upload-alt fa-3x' />
          </div>
          <div className={css.flex3}>
            <p>When you click 'Upload Form' your application form will be sent to the Bank for Authorisation.</p>
            <p>
              You can upload the form anytime via Action icon <i className='fas fa-upload' /> on the Bank feed management page
            </p>
          </div>
        </div>

        <div className={css.dividerDark} />

        {feed.formUploaded && (
          <div className={[css.note, css.orangeTag].join(' ')}>
            <p>You have already lodged an application for this Bank Feed.</p>
            <p>
              If you have amended the form you can click
              <br /> Upload Now to lodge the updated form.
            </p>
            <p>
              <a href='#' onClick={() => downloadForm(feed.feedId)}>
                {' '}
                Download Current Application Form
              </a>
            </p>
          </div>
        )}

        <div className={[css.dFlex, css.contentEvenSpace].join(' ')}>
          <div>
            <Button type='button' variant='contained' size='small' onClick={onClose}>
              I'll Upload Later
            </Button>
          </div>
          <input accept='.pdf' className={css.hideInput} id='contained-button-file' type='file' onChange={this.handleUploadFile} />
          <label htmlFor='contained-button-file'>
            <Button variant='contained' color='primary' size='small' component='span'>
              {this.state.uploading ? 'Uploading...' : 'Upload Form'}
            </Button>
          </label>
        </div>
      </div>
    );
  }
}

export default UploadBankFeedForm;



// WEBPACK FOOTER //
// ./src/components/FeedManagment/UploadBankFeedForm.js